import apiClient from './apiClient';
import { closeAtToRemaining, normalizeRoundPayload } from '../utils/soiDaoUtils';

export const soiDaoService = {
  getRooms: () => apiClient.get('/soi-dao/rooms').then((res) => res.data),

  getRound: (roomId) =>
    apiClient.get(`/soi-dao/rooms/${roomId}/round`).then((res) =>
      normalizeRoundPayload(res.data),
    ),

  getHistory: (roomId, limit = 10) =>
    apiClient
      .get(`/soi-dao/rooms/${roomId}/history`, { params: { limit } })
      .then((res) => res.data),

  play: (payload) =>
    apiClient.post('/soi-dao/play', payload).then((res) => res.data),

  getPlays: (params) =>
    apiClient.get('/soi-dao/plays', { params }).then((res) => res.data),

  getOverview: () =>
    soiDaoService.getRooms().then((rooms) =>
      Promise.all(
        rooms.map((room) =>
          soiDaoService.getRound(room.id).then((roundData) => ({
            ...room,
            ...(roundData.room || {}),
            round: roundData.round,
            remainingTime:
              roundData.remainingTime ||
              closeAtToRemaining(roundData.round?.closeAt),
            prizes: roundData.prizes || room.prizes,
            entryCount: roundData.round?.entryCount ?? 0,
          })),
        ),
      ),
    ),
};
